module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv8-455822bf1e1b81f3159b4bdff7803ade.jpg";